var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    { staticClass: "container", class: { "is-safari": _vm.isSafari } },
    [
      _c(
        "transition",
        { attrs: { mode: "out-in", name: "fast-fade" } },
        [
          _vm.initialized && _vm.state
            ? _c(
                "w-row",
                {
                  key: "main",
                  style: { maxHeight: "100%" },
                  attrs: { grow: "", shrink: "" },
                },
                [
                  _c(
                    "w-col",
                    { style: { maxHeight: "100%" }, attrs: { grow: "" } },
                    [
                      _c(
                        "app-browse-actions",
                        {
                          staticClass: "actions",
                          attrs: {
                            state: _vm.state,
                            "show-selected-items-count": "",
                          },
                        },
                        [
                          _vm._t("extra-buttons", null, {
                            slot: "extra-buttons",
                          }),
                          _vm._t("browse-action-buttons", null, {
                            slot: "browse-action-buttons",
                          }),
                        ],
                        2
                      ),
                      _c("app-browse-search-table", {
                        attrs: { state: _vm.state },
                        on: {
                          click: function ($event) {
                            return _vm.onClick($event)
                          },
                        },
                      }),
                      _c(
                        "w-row",
                        { staticClass: "bottom" },
                        [
                          _c("app-browse-total-items-result", {
                            attrs: { state: _vm.state },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-modal",
                    {
                      attrs: { "escape-close": "" },
                      model: {
                        value: _vm.state.showSearch,
                        callback: function ($$v) {
                          _vm.$set(_vm.state, "showSearch", $$v)
                        },
                        expression: "state.showSearch",
                      },
                    },
                    [_c("app-filter-modal", { attrs: { state: _vm.state } })],
                    1
                  ),
                  _c(
                    "w-modal",
                    { attrs: { value: _vm.state.customReportsModalOpen } },
                    [
                      _c("app-custom-report-create", {
                        attrs: { "browse-id": _vm.state.browse.ID },
                        on: {
                          close: function ($event) {
                            _vm.state.customReportsModalOpen = false
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "w-row",
                { key: "load", style: { flexGrow: 1, alignItems: "center" } },
                [
                  _c(
                    "w-col",
                    { style: { flexGrow: 1 } },
                    [_c("app-delayed-progress")],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
      _vm.state && _vm.state.openedExtraScriptButtonArgsModal != null
        ? _c(
            "w-modal",
            {
              attrs: {
                value:
                  _vm.state &&
                  _vm.state.openedExtraScriptButtonArgsModal != null,
              },
            },
            [
              _c("app-script-args-input-modal", {
                attrs: { script: _vm.state.openedExtraScriptButtonArgsModal },
                on: {
                  close: function ($event) {
                    _vm.state.openedExtraScriptButtonArgsModal = null
                  },
                  confirm: function ($event) {
                    return _vm.state.runBrowseScriptWithArgs($event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.state && _vm.state.browseToFileModalOpen
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [_c("app-browse-to-file-modal", { attrs: { state: _vm.state } })],
            1
          )
        : _vm._e(),
      _vm.state && _vm.state.printLabelsModalOpen
        ? _c("app-print-labels-modal", { attrs: { state: _vm.state } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }